import "bootstrap-icons/font/bootstrap-icons.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./user.css";

import { Badge, Button, Dropdown, Input, Menu, Popover, Segmented, Table } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllStaff } from "../../redux/actions/user/getStaffAction";

const FILTER_STYLE = { marginBottom: 12 };
const FILTER_LABEL = { display: "block", marginBottom: 4, color: "rgba(0,0,0,0.65)", fontSize: 12 };

const columns = [
  {
    title: "S.No",
    key: "sNo",
    width: 60,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    dataIndex: "username",
    key: "username",
    render: (name, record) => <Link to={`/hr/staffs/${record.id}/`}>{name}</Link>,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Action",
    dataIndex: "id",
    key: "action",
    render: (id) => (
      <Link to={`/hr/staffs/${id}/`}>
        <button className="btn btn-dark btn-sm">View</button>
      </Link>
    ),
  },
];

const menuItems = columns.map((item) => ({ key: item.key, label: <span>{item.title}</span> }));

function CustomTable({
  list,
  status,
  onChangeStatus,
  columnItems,
  columnsToShow,
  setColumnsToShow,
  colVisibilityClickHandler,
  addKeys,
  filteredList,
}) {
  const total = (filteredList || list || []).length;
  const dataSource = filteredList ? addKeys(filteredList) : addKeys(list || []);
  const hasCol = (key) =>
    Array.isArray(columnsToShow) && columnsToShow.some((c) => c.key === key);
  return (
    <div className="list-page-table-outer">
      {list && (
        <div className="d-flex flex-wrap align-items-center gap-2 list-page-header mb-2" style={{ marginBottom: "8px" }}>
          <Segmented
            className="text-center rounded danger"
            size="middle"
            options={[
              { label: <span><i className="bi bi-person-lines-fill"></i> Active</span>, value: "true" },
              { label: <span><i className="bi bi-person-dash-fill"></i> Inactive</span>, value: "false" },
            ]}
            value={status}
            onChange={onChangeStatus}
          />
        </div>
      )}
      <div className="list-page-table-container" style={{ minHeight: 420 }}>
        <div className="list-page-table-inner">
          <div className="list-page-table-wrap list-page-table-scroll-450">
            {/* Desktop Table */}
            <div className="d-none d-lg-block">
              <Table
                scroll={{ x: true, y: 450 }}
                loading={!list}
                pagination={{
                  defaultPageSize: 10,
                  pageSizeOptions: [10, 20, 50, 100, 200],
                  showSizeChanger: true,
                  hideOnSinglePage: false,
                  showTotal: (_, range) =>
                    total ? `${range[0]}-${range[1]} of ${total} items` : "0 items",
                }}
                columns={columnsToShow}
                dataSource={dataSource}
              />
            </div>

            {/* Mobile Cards */}
            <div className="d-lg-none staff-mobile-cards">
              {dataSource && dataSource.length > 0 ? (
                <div className="staff-mobile-list">
                  {dataSource.map((record, idx) => (
                    <div key={record.key ?? record.id ?? idx} className="staff-mobile-card">
                      <div className="staff-mobile-card-body">
                        <div className="staff-mobile-title-row">
                          {hasCol("sNo") && (
                            <span className="staff-mobile-sno">{idx + 1}</span>
                          )}
                          {hasCol("username") && (
                            <div className="staff-mobile-name">
                              <Link to={`/hr/staffs/${record.id}/`}>
                                {record.username || "—"}
                              </Link>
                            </div>
                          )}
                        </div>

                        {hasCol("role") && (
                          <div className="staff-mobile-line">
                            <span className="staff-mobile-label">Role</span>
                            <span className="staff-mobile-value">{record.role || "—"}</span>
                          </div>
                        )}

                        {hasCol("action") && (
                          <div className="staff-mobile-actions">
                            <Link to={`/hr/staffs/${record.id}/`}>
                              <Button
                                type="primary"
                                size="small"
                                shape="round"
                                block
                              >
                                View
                              </Button>
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <p className="text-muted mb-0">No staff found</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const GetAllUser = ({ refreshTrigger, addStaffButton }) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.users.list);
  const [status, setStatus] = useState("true");
  const [columnItems, setColumnItems] = useState([]);
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filters, setFilters] = useState({ name: "", role: "" });

  useEffect(() => {
    dispatch(loadAllStaff({ status }));
  }, [dispatch, refreshTrigger, status]);

  useEffect(() => {
    setColumnItems(menuItems);
    setColumnsToShow(columns);
  }, []);

  const colVisibilityClickHandler = (col) => {
    const ifColFound = columnsToShow.find((item) => item.key === col.key);
    if (ifColFound) {
      setColumnsToShow(columnsToShow.filter((item) => item.key !== col.key));
    } else {
      const foundIndex = columns.findIndex((item) => item.key === col.key);
      const foundCol = columns.find((item) => item.key === col.key);
      const updated = [...columnsToShow];
      updated.splice(foundIndex, 0, foundCol);
      setColumnsToShow(updated);
    }
  };

  const addKeys = (arr) => (arr || []).map((i) => ({ ...i, key: i.id }));
  const nameLower = (filters.name || "").trim().toLowerCase();
  const roleLower = (filters.role || "").trim().toLowerCase();
  const filteredList =
    list && (nameLower || roleLower)
      ? list.filter((i) => {
          if (nameLower && !(i.username || "").toLowerCase().includes(nameLower)) return false;
          if (roleLower && !(i.role || "").toLowerCase().includes(roleLower)) return false;
          return true;
        })
      : list;
  const activeFilterCount = [filters.name, filters.role].filter(Boolean).length;

  const filterContent = (
    <div style={{ width: 260 }}>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Name</label>
        <Input
          placeholder="Filter by name"
          value={filters.name}
          onChange={(e) => setFilters((f) => ({ ...f, name: e.target.value }))}
          allowClear
        />
      </div>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Role</label>
        <Input
          placeholder="Filter by role"
          value={filters.role}
          onChange={(e) => setFilters((f) => ({ ...f, role: e.target.value }))}
          allowClear
        />
      </div>
      <div style={{ textAlign: "center", marginTop: 8 }}>
        <Button size="small" onClick={() => setFilters({ name: "", role: "" })}>
          Clear All Filters
        </Button>
      </div>
    </div>
  );

  return (
    <div className="card card-custom list-page-fill-viewport staff-list-page">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 list-page-header mb-2" style={{ marginBottom: "8px", flexWrap: "wrap", gap: 8 }}>
          <h5 className="mb-0">
            <span className="ms-2">Staff List</span>
          </h5>
          <div className="staff-header-actions">
            {list && (
              <>
                <Popover
                  content={filterContent}
                  title="Filters"
                  trigger="click"
                  open={filterVisible}
                  onOpenChange={setFilterVisible}
                  placement="bottomLeft"
                >
                  <Badge count={activeFilterCount} size="small" offset={[-2, 2]}>
                    <Button
                      type="primary"
                      className="filter-icon-btn"
                      icon={<FilterOutlined />}
                      onClick={() => setFilterVisible((v) => !v)}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Badge>
                </Popover>
                <Dropdown overlay={<Menu onClick={colVisibilityClickHandler} items={columnItems} />} placement="bottomRight">
                  <Button className="column-visibility">Column Visibility</Button>
                </Dropdown>
              </>
            )}
            {addStaffButton}
          </div>
        </div>
        <CustomTable
          list={list}
          status={status}
          onChangeStatus={setStatus}
          columnItems={columnItems}
          columnsToShow={columnsToShow}
          setColumnsToShow={setColumnsToShow}
          colVisibilityClickHandler={colVisibilityClickHandler}
          addKeys={addKeys}
          filteredList={filteredList}
        />
      </div>
    </div>
  );
};

export default GetAllUser;
